const VTN = () => import('../views/vtn.vue')
const PLAN = () => import('../views/Planos.vue')
const CASAL = () => import('../views/CargosSalarios.vue')
const DIV = () => import('../views/DividaAtiva.vue')
const CSERVICO = () => import('../views/carta-de-servicos.vue')

export default [
  { name: 'viewVtn', path: '/servicos/vtn', component: VTN, meta: { acl: true } },
  { name: 'viewPlan', path: '/servicos/planos', component: PLAN, meta: { acl: true } },
  { name: 'viewCaSal', path: '/servicos/cargos-salarios', component: CASAL, meta: { acl: true } },
  { name: 'viewDev', path: '/servicos/divida-ativa', component: DIV },
  { name: 'viewCServico', path: '/servicos/carta-de-servicos', component: CSERVICO, meta: { acl: true } }
]
